import api from "./api";
import TokenService from "./token.service";
import apiData from "./api_data";

const register = (username, email, password) => {
  return api.post("/auth/signup", {
    username,
    email,
    password
  });
};

const login = (username, password) => {
  return api
    .post("/users/authenticate", {
      username,
      password
    })
    .then((response) => {
      if (response.data.accessToken) {
        TokenService.setUser(response.data);
      }

      return response.data;
    });
};

const logout = () => {
  callLogoutApi();
};

const getCurrentUser = () => {
  // Session-only: no localStorage fallback, so the login does not survive a browser close.
  const fromSession = sessionStorage.getItem("user");
  return fromSession ? JSON.parse(fromSession) : null;
};

const callLogoutApi = () => {
  // Logout telemetry is best-effort. It must NEVER prevent the user from logging out:
  // previously, an empty/missing `UserTabs` (e.g. clicking Logout before navigating anywhere,
  // which leaves UserTabs as the `[]` set at login) made `UserTabs[UserTabs.length - 1]`
  // undefined and threw synchronously here — so ClearAndLogout() never ran and the button
  // appeared to do nothing. Guard the payload (mirroring the `?.length` guard in listItems.js
  // / utils.js) and guarantee ClearAndLogout() on every path.
  try {
    const user = TokenService.getUser();
    const UserTabs = JSON.parse(sessionStorage.getItem("UserTabs"));

    if (user && UserTabs?.length) {
      UserTabs[UserTabs.length - 1].endDateTime = new Date();

      const userLogDetails = {
        userId: user.userId,
        loginDate: JSON.parse(sessionStorage.getItem("LoginDate")),
        logoutDate: new Date(),
        user_Tabs: UserTabs,
      };

      apiData
        .userLogDetails(userLogDetails)
        .then(() => ClearAndLogout())
        .catch(() => ClearAndLogout());
      return;
    }
  } catch (e) {
    // fall through — log out regardless of telemetry failure
  }

  ClearAndLogout();
}

const ClearAndLogout = () =>{
  TokenService.removeUser();
  sessionStorage.clear();
  localStorage.clear();
  window.location.reload();
}

const AuthService = {
  register,
  login,
  logout,
  getCurrentUser,
  callLogoutApi,
};

export default AuthService;
